<script setup>
import { computed, ref } from "vue";
import { FormModal } from "@Components/Modal";
import { useForm } from "@/form";
import { FormInput, FormLabel } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import { ArrowRightIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import { getTitleStyle } from "@Utils/project";

const props = defineProps({
    language: String,
});

const emit = defineEmits(["submit"]);

const { t: __ } = useI18n();

const modal = ref();

const form = useForm({
    keywords: "",
    language: props.language,
});

const items = ref({});

const show = (keyword) => {
    modal.value?.show();

    if (keyword) {
        form.keywords = keyword;
        search();
    }
};

const hide = () => {
    modal.value?.hide();
};

const search = async () => {
    if (form.keywords.length === 0) {
        return;
    }

    form.language = props.language;

    items.value = {};
    const response = await form.post("single_mode_keywords_source_search");
    items.value = response;
};

const selectItem = (item) => {
    emit("submit", item);
    hide();
};

const filteredItems = computed(() => {
    let o = {};
    for (const key in items.value) {
        let style = getTitleStyle(key) ?? { key: key, name: key };

        if (items.value[key].length > 0) {
            o[style.name] = items.value[key];
        }
    }
    return o;
});

defineExpose({ show, hide });
</script>

<template>
    <FormModal class="sm:max-w-2xl" ref="modal" :title="__('Mots clés')" :max-height="Object.keys(filteredItems).length > 0 ? '80vh' : undefined">
        <template #body>
            <form @submit.prevent="search">
                <FormLabel for="keywords-source-keywords">{{ __("Mots clés") }}</FormLabel>
                <div class="flex justify-center gap-3 mt-2">
                    <div class="flex-1">
                        <FormInput id="keywords-source-keywords" v-model="form.keywords" :errors="form.getErrors('keywords')" :placeholder="''" :z="1" />
                    </div>
                    <div class="mt-[2px] flex-none">
                        <PrimaryButton type="submit" :processing="form.processing" :icon="ArrowRightIcon" :z="1" />
                    </div>
                </div>
            </form>

            <div v-if="Object.keys(filteredItems).length > 0" class="mt-3">
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                    {{ __("Sélectionnez un titre à utiliser") }}
                </div>

                <div class="grid gap-3 mt-3 sm:grid-cols-2">
                    <div v-for="(items, key) in filteredItems" :key="key">
                        <div class="block text-lg font-medium leading-6 text-gray-900 dark:text-white">
                            {{ __(key) }}
                        </div>

                        <div class="-mx-2 mt-1">
                            <div
                                @click="selectItem(item)"
                                v-for="(item, index) in items"
                                :key="index"
                                class="p-2 rounded-md cursor-pointer dark:hover:bg-gray-800 hover:bg-gray-50">
                                <div class="flex">
                                    <div class="text-sm line-clamp-2 text-gray-900 dark:text-white">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div v-if="items.length > 0" class="mt-3">
                <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                    {{ __("Sélectionnez un titre à utiliser") }}
                </div>
                <div class="-mx-2">
                    <div
                        @click="selectItem(item)"
                        v-for="(item, index) in items"
                        :key="index"
                        class="p-2 rounded-md cursor-pointer dark:hover:bg-gray-800 hover:bg-gray-50">
                        <div class="flex">
                            <div class="text-sm line-clamp-2 text-gray-900 dark:text-white">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
            </div> -->
        </template>
    </FormModal>
</template>
